import * as angular from 'angular';
import { AncillariesUtilsService } from '../../shared/ib-web-ancillaries-utils';


export class AncillariesSpeqTransformer {
    constructor (
        private $filter: ng.IFilterService,
        private AncillariesConstants: AncillariesConstant,
        private AncillariesUtilsService: AncillariesUtilsService,
        private CurrencyService: CurrencyService
    ) {}

    generateAncillariesTripsSpeqs = (ancilleriesSpeqInfo: any) => {
        const segmentList = [];
        if(ancilleriesSpeqInfo.slices[0]) {
            segmentList.push(ancilleriesSpeqInfo.slices[0].id);
        }
        return segmentList;
    };

    generateSpeqsTripsInformation = (ancillariesSlices: any, ancillariesTrips: any, cachedData: any, currency: any) => {
        const passengersSpeqs = [];
        const segmentsInfo = this.AncillariesUtilsService.getMmBbookingSegmentInformation();

        const speqTitle = (speqInfo: any): string => {
            let speqDescription = '';
            switch (speqInfo.subtype) {
                    case 'BICYCLE':
                        speqDescription = this.$filter('translate')('SPEQS_BICYCLE');
                        break;
                    case 'SURFBOARD':
                        speqDescription = this.$filter('translate')('SPEQS_SURFBOARD_TITLE');
                        break;
                    case 'SKI_SNOW':
                        speqDescription = this.$filter('translate')('SPEQS_SKI_SNOW');
                        break;
                    case 'GOLF_EQUIPMENT':
                        speqDescription = this.$filter('translate')('SPEQS_GOLF_EQUIPMENT');
                        break;
                    case 'FISHING_EQUIPMENT':
                        speqDescription = this.$filter('translate')('SPEQS_FISHING_TITLE');
                        break;
                    case 'SCUBA_DIVING':
                        speqDescription = this.$filter('translate')('SPEQS_SCUBA_TITLE');
                        break;
            }
            return speqDescription;
        };

        const getInfoSegment = (segmentId: any, segmentsInfo: any): any => {
            let i = 0, isFound = false;
            const info = { departure: null, arrival: null };
            while (i < segmentsInfo.length && !isFound) {
                if (segmentsInfo[i].id === segmentId) {
                    info.arrival = segmentsInfo[i].arrival.city;
                    info.departure = segmentsInfo[i].departure.city;
                    isFound = true;
                }
                i++;
            }
            return info;
        };

        const getPiecePriceFormmated = (trip: any): any => {
            let i, k;
            for (i = 0; i < trip.pieces.length; i++) {
                for (k = 0; k < trip.pieces[i].availablePriceRanges.length; k++) {
                    trip.pieces[i].availablePriceRanges[k].amountPrice = this.CurrencyService.formatPrice(currency, trip.pieces[i].availablePriceRanges[k].amount, false, false, true);
                }
            }
        };

        const getInfoPassenger = (id: any): any => {
            const pasInfo: any = {};
            angular.forEach(cachedData.passengers, (pas) => {
                if (pas.passengerId === id) {
                    pasInfo.name = pas.externalPersonalInfo ? pas.externalPersonalInfo.name : pas.personalInfo.name;
                    pasInfo.surname = pas.externalPersonalInfo ? pas.externalPersonalInfo.firstSurname + ' ' + pas.externalPersonalInfo.lastSurname : pas.personalInfo.surname;
                    pasInfo.infant = pas.infant;
                }
            });

            return pasInfo;
        };
        for (let i = 0; i < ancillariesTrips.length; i++) {
            if (ancillariesTrips[i].status.code === this.AncillariesConstants.GENERAL_STATUS.AVAILABLE) {
                angular.forEach(ancillariesTrips[i].passengers, (passengerTrip) => {
                    if (passengerTrip.maxAdditionalPieces > 0) {
                        const passenger = {
                            id: passengerTrip.id,
                            trips: [],
                            info: getInfoPassenger(passengerTrip.id)
                        };
                        const trip: any = {
                            id: ancillariesTrips[i].id,
                            pieces: [],
                            maxAdditionalPieces: passengerTrip.maxAdditionalPieces,
                            speqsChoosed: 0,
                            totalPrice: 0
                        };
                        let isFound = false;
                        angular.forEach(ancillariesSlices, (slice) => {
                            if (slice.id === ancillariesTrips[i].id) {
                                if (slice.segmentIds.length > 1) {
                                    trip.departure = getInfoSegment(slice.segmentIds[0], segmentsInfo).departure;
                                    trip.arrival = getInfoSegment(slice.segmentIds[slice.segmentIds.length - 1], segmentsInfo).arrival;
                                } else {
                                    angular.extend(trip, getInfoSegment(slice.segmentIds[0], segmentsInfo));
                                }
                            }
                        });

                        angular.forEach(passengerTrip.pieces, (pasPieces) => {
                            if (pasPieces.status.code === this.AncillariesConstants.GENERAL_STATUS.AVAILABLE) {
                                pasPieces.quantySelected = 0;
                                pasPieces.description = speqTitle(pasPieces);
                                trip.pieces.push(pasPieces);
                            } else if (pasPieces.status.code === 'NOT_AVAILABLE' && pasPieces.subtype === 'SURFBOARD') {
                                pasPieces.quantySelected = pasPieces.purchasedPieces;
                                pasPieces.description = speqTitle(pasPieces);
                                trip.pieces.push(pasPieces);
                            }
                        });

                        for (let j = 0; j < passengersSpeqs.length; j++) {
                            if (passenger.id === passengersSpeqs[j].id) {
                                getPiecePriceFormmated(trip);
                                passengersSpeqs[j].trips.push(trip);
                                isFound = true;
                            }
                        }
                        if (!isFound) {
                            getPiecePriceFormmated(trip);
                            passenger.trips.push(trip);
                            passengersSpeqs.push(passenger);
                        }
                    }
                });
            }
        }

        return passengersSpeqs;
    };

    generateBaggageSpeqsHaveInfo = (speqsTripInfo: any, speqsName: string) => {
        let text, count;

        const concatData = (quantity: any, description: any, text: any, type: any) => {
            if (text === null) {
                if (type === this.AncillariesConstants.TYPE_ANCILLARIE.BAGGAGE) {
                    text = quantity.toString() + ' ' +
                        (quantity === 1 ? this.$filter('translate')('BAGGAGE_SINGULAR_TEXT') : this.$filter('translate')('BAGGAGE_PLURAL_TEXT')) + ' ' + description;
                } else {
                    text = quantity.toString() + ' ' + description;
                }
            } else {
                if (type === this.AncillariesConstants.TYPE_ANCILLARIE.BAGGAGE) {
                    text += ', ' + quantity.toString() + ' ' +
                        (quantity === 1 ? this.$filter('translate')('BAGGAGE_SINGULAR_TEXT') : this.$filter('translate')('BAGGAGE_PLURAL_TEXT')) + ' ' + description;
                } else {
                    text += ', ' + quantity.toString() + ' ' + description;
                }
            }
            return text;
        };
        angular.forEach(speqsTripInfo, (data) => {
            angular.forEach(data.trips, (trip) => {
                text = null;
                angular.forEach(trip.pieces, (piece) => {
                    count = 0;
                    count += piece.purchasedPieces ? piece.purchasedPieces : 0;
                    count += piece.franchisePieces ? piece.franchisePieces : 0;
                    count += piece.extraPieces && piece.extraPieces.units ? piece.extraPieces.units : 0;
                    if (count > 0) {
                        text = concatData(count, piece.description, text, speqsName);
                    }
                });
                trip.text = text;
            });
        });

        return speqsTripInfo;
    };

    countSpeqsTotal = (passengerSpeqsTrips: any) => {
        let count = 0;
        angular.forEach(passengerSpeqsTrips, (passenger) => {
            angular.forEach(passenger.trips, (trip) => {
                angular.forEach(trip.pieces, (piece) => {
                    count += piece.purchasedPieces;
                    count += piece.quantySelected;
                });
            });
        });
        return count;
    };
}

AncillariesSpeqTransformer.$inject = ['$filter', 'AncillariesConstants', 'AncillariesUtilsService', 'CurrencyService'];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('AncillariesSpeqTransformer', AncillariesSpeqTransformer);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('AncillariesSpeqTransformer', AncillariesSpeqTransformer);
}
